import React, { useState } from 'react'
import AdminHeading from '../Heading/AdminHeading'
import ListTable from 'Components/CommonComponents/ListTable'
import { ClipLoader } from 'react-spinners'
import ErrorModal from 'Components/Other Functions/popup'
import AlertMessage from 'Components/Other Functions/AlertMessage'
import { useSelector } from 'react-redux'
import GetApiService from 'Components/Api/getapiService'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

const AdminPurchaseEntriesList = () => {
    const [ loading,setLoading] = useState(false)
    const [ showModal,setShowModal] = useState(false)
    const [ errorMessage,setErrorMessage] = useState("")
    const [ showError,setShowError] = useState(false)
    const allStates = useSelector((state) => state);
    const navigate = useNavigate()
    const adminLoggedIn = allStates.reducer1;
    const clientCode = adminLoggedIn.ClientCode;
    const apiService = new GetApiService(clientCode);

    const fetchData = async () => {
        try {
          const data = await apiService.fetchAllRDPurchaseList();
          return data;
        } catch (e) {
          console.log(e);
        }
      };
    const {
        data:RDPurchaseList,
        isLoading,
        isError,
      } = useQuery({
        queryKey: ["getRdPurchaseList"],
        queryFn: fetchData,
        refetchOnWindowFocus: false,
        // cacheTime: 1000 * 60 * 2,
        staleTime: 1000 * 60 * 2,
      }); 
     

    const handleEditData = (product)=>{
        navigate(`/edit_purchase_entry_new/${product?.Id}`)
    }
    const columns = [
        {key:"LotNumber",label:"Lot Number"},
        {key:"Id",label:"RD Purchase Id"},
        {key:"VendorName",label:"Vendor Name"},
        {key:"PurchaseDate",label:"Purchase Date"},
        {key:"InvoiceNo",label:"Invoice No"},
        {key:"PurchaseStatus",label:"Purchase Status"},
        {key:"TotalPurchaseAmount",label:"Total Purchase Amount"},
    ]
  return (
    <>
    <div>
      <AdminHeading />
      {loading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={()=>{}} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        )}
    </div>
      <ListTable
      columns={columns}
      handleEditData={handleEditData}
      data={RDPurchaseList?.length ? [...RDPurchaseList].reverse( ) : []}
      />
    </>
  )
}

export default AdminPurchaseEntriesList
